(function(){
  function initHouse(root){
    var section = root.querySelector('[data-vp-house]');
    if(!section || section.dataset.vpInit) return;
    section.dataset.vpInit = '1';

    var targets = section.querySelectorAll('.vp-reveal, .vp-house-media');
    if(!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches){
      targets.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:0, rootMargin:'0px 0px -8% 0px'});
    targets.forEach(function(el){ io.observe(el); });

    /* safety net: never leave content permanently hidden */
    setTimeout(function(){ targets.forEach(function(el){ el.classList.add('in'); }); }, 3800);
  }
  function boot(){ initHouse(document); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ initHouse(e.target); });
})();